module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "add-device fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('ExitConfirmation', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exitConfirmationDialog),
      expression: "exitConfirmationDialog"
    }],
    attrs: {
      "exitConfirmationDialog": _vm.exitConfirmationDialog
    },
    on: {
      "update:exitConfirmationDialog": function($event) {
        _vm.exitConfirmationDialog = $event
      },
      "update:exit-confirmation-dialog": function($event) {
        _vm.exitConfirmationDialog = $event
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exitConfirmationDialog),
      expression: "!exitConfirmationDialog"
    }],
    staticClass: "div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically"
  }, [_c('p', {
    staticClass: "equipment-data"
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.equipmentData')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "div-center-vertically div-right-horizontally"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    staticClass: "close-icon"
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "device-content-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('DeviceEditor', {
    attrs: {
      "deviceDataProp": _vm.deviceData,
      "deviceLength": _vm.length,
      "pluviometricChartData": _vm.pluviometricChartData
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d805b2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddDevice.vue
// module id = 1726
// module chunks = 0